import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import LanguageTextInput from '@/configuration/components/LanguageTextInput/LanguageTextInput'

import * as Styles from './styles'

const ConsentTextField = ({ title, description, languages, value, onChange, missingLanguages, disabled }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Styles.Container>
      <Styles.Header>
        <Text type="bodyMBold">{title}</Text>
        <Text type="bodyMRegular">{description}</Text>
      </Styles.Header>
      <LanguageTextInput
        languages={languages}
        value={value}
        onChange={onChange}
        validateEmptyOnBlur={false}
        externalErrorLanguages={missingLanguages}
        inputLabel={title}
        helperText={t('Este campo es obligatorio')}
        showInputError
        backgroundColor={theme.colors.background.primary}
        disabled={disabled}
      />
    </Styles.Container>
  )
}

export default ConsentTextField
